/**
 * Normaliza competência para YYYY-MM (perapur / filtros da API eSocial).
 * Aceita Date, YYYY-MM, YYYY-MM-DD, ISO com timezone e mm/aaaa.
 * @param {unknown} value
 * @returns {string} YYYY-MM ou "" se inválido
 */
export function competenciaParaYm(value) {
  if (value == null || value === "") return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getUTCFullYear();
    const m = value.getUTCMonth() + 1;
    return `${y}-${m < 10 ? `0${m}` : m}`;
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const br = raw.match(/^(\d{1,2})\/(\d{4})$/);
  if (br) {
    const mm = Number(br[1]);
    if (mm >= 1 && mm <= 12) {
      return `${br[2]}-${mm < 10 ? `0${mm}` : mm}`;
    }
    return "";
  }

  const isoYm = raw.match(/^(\d{4})-(\d{2})(?:$|[-T\s])/);
  if (isoYm) {
    const mm = Number(isoYm[2]);
    if (mm >= 1 && mm <= 12) return `${isoYm[1]}-${isoYm[2]}`;
    return "";
  }

  // ISO com fuso (ex.: 2023-05-31T21:00:00.000Z) — usa UTC do instante.
  const asDate = new Date(raw);
  if (!Number.isNaN(asDate.getTime()) && /T|Z|[+-]\d{2}:?\d{2}$/.test(raw)) {
    const y = asDate.getUTCFullYear();
    const m = asDate.getUTCMonth() + 1;
    return `${y}-${m < 10 ? `0${m}` : m}`;
  }

  return raw.length >= 7 ? raw.slice(0, 7) : "";
}

/**
 * Exibe competência em mm/aaaa.
 * @param {unknown} value
 * @returns {string}
 */
export function competenciaParaPt(value) {
  const ym = competenciaParaYm(value);
  if (!ym || ym.length < 7) return value ? String(value) : "—";
  const [y, m] = ym.split("-");
  return `${m}/${y}`;
}
